import React from "react";
import { ListItem, ListItemText } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import ArticleText from "./ArticleText";

const ArticleCommentItem = props => {
	const theme = useTheme();
	let commentLine = props.commentLine;
	return (
		<ListItem disableGutters={true} divider={true} key={commentLine.key}>
			{commentLine.type ? (
				<ListItemText
					style={{
						flexBasis: "5%",
						color:
							commentLine.type === "噓"
								? theme.palette.error.dark
								: commentLine.type === "推"
								? theme.palette.primary.dark
								: theme.palette.secondary.dark
					}}
					primary={commentLine.type}
				/>
			) : (
				""
			)}
			{commentLine.author ? (
				<ListItemText
					style={{ flexBasis: "15%" }}
					primary={commentLine.author}
				/>
			) : (
				""
			)}
			<ListItemText style={{ flexBasis: "70%" }}>
				<ArticleText
					text={commentLine.text}
					key={commentLine.key}
				/>
			</ListItemText>

			{commentLine.timestamp ? (
				<ListItemText
					style={{ flexBasis: "10%" }}
					primary={commentLine.floor + "F"}
					secondary={commentLine.timestamp}
				/>
			) : (
				""
			)}
		</ListItem>
	);
};
export default ArticleCommentItem;
